import React from 'react';
import { Asset } from '../../../types/asset';
import { RichText } from '../../richText';
import { Document } from '@contentful/rich-text-types';
import classnames from 'classnames';
import { Block } from '../../other/block';

export interface GatedContentProps {
  title: string;
  coverImage: Asset;
  formEmbed: string;
  content: Document;
}

export const GatedContent: React.FC<GatedContentProps> = ({title, coverImage, formEmbed, content}) => {
  const className = classnames('w-full mx-auto py-16 md:py-20 px-8 pt-24 md:pt-32 max-w-screen-lg relative gap-24 md:grid md:grid-rows-1 md:grid-cols-2');

  return (
    <Block backgroundColour="transparent" noSpacing={true}>
      <hr className="absolute left-0 hidden w-screen border-black border-solid border-b-px md:block top-hr" />
      <div className={className}>
        <div className="mb-8 md:border md:border-black md:border-solid md:mb-0">
          <img
            className="w-full"
            src={coverImage.url}
            alt={coverImage.name}
          />
        </div>

        <div className="md:border md:border-black md:border-solid md:h-full bg-neutral md:p-8">
          <h1 className="mb-8 text-2xl font-bold">{title}</h1>
          <div dangerouslySetInnerHTML={{__html: formEmbed}}/>
        </div>
      </div>
      <div className="max-w-screen-lg px-8 pb-20 mx-auto md:pt-0 md:grid md:grid-rows-1 md:grid-cols-2">
        <RichText content={content} />
      </div>
    </Block>
  );
};
